<template lang="">
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="3">
				<!-- 공장 -->
				<sf-select-group
					:label="getMessage_('SWCC000015')"
					:inputValue="plant"
					:options="plants"
					:onChange="value => this.changeValue({ name: 'plant', value })"
				/>
			</el-col>
			<!-- Date -->
			<el-col :span="5">
				<div class="sf-input-group-wrapper">
					<span class="sf-input-group-wrapper__label">{{ getMessage_('SWCC000204') }}</span>
					<div class="w-100 el-row">
						<div class="el-col el-col-24">
							<el-date-picker
								:style="{ height: '38px' }"
								v-model="searchDate"
								type="daterange"
								align="right"
								start-placeholder="Start Date"
								end-placeholder="End Date"
								range-separator="~"
								format="yyyy-MM-dd"
								@change="value => onChangeSelect('searchDate', value)"
							/>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="3">
				<!-- type -->
				<sf-select-group
					:label="getMessage_('SWCC000315')"
					placeholder="Type"
					:inputValue="this.logType"
					:options="this.logTypes"
					:onChange="value => onChangeSelect('logType', value)"
				/>
			</el-col>
			<el-col :span="4">
				<div class="sf-input-group-wrapper">
					<span class="sf-input-group-wrapper__label">{{ getMessage_('SWCC000207') }}</span>
					<el-input
						:placeholder="getMessage_('SWCC000207')"
						:value="this.procId"
						@input="value => changeValue({ name: 'procId', value })"
					/>
				</div>
			</el-col>
			<el-col :span="4">
				<div class="sf-input-group-wrapper">
					<span class="sf-input-group-wrapper__label">{{ getMessage_('SWCC000210') }}</span>
					<el-input
						:placeholder="getMessage_('SWCC000210')"
						:value="this.message"
						@input="value => changeValue({ name: 'message', value })"
					/>
				</div>
			</el-col>
			<el-col :span="2">
				<div class="sf-input-group-wrapper">
					<span class="sf-input-group-wrapper__label">Check</span>
					<el-checkbox :value="this.chkFlag" @change="value => onChangeSelect('chkFlag', value)" />
				</div>
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button line icon="search" v-if="isButton_(scrId, 'CR')" :onClick="() => searchList()">{{ getButtonMsg_(scrId, 'CR') }}</sf-button>
		</template>
	</sf-search-layout>
</template>
<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/ErrorLog/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		var date = new Date();
		var month = parseInt(date.getMonth() + 1);
		var day = date.getDate();
		if (month < 10) month = '0' + month;
		if (day < 10) day = '0' + day;
		var currentDate = date.getFullYear() + '-' + month + '-' + day;
		return {
			searchDate: [new Date(currentDate), new Date(currentDate)]
		};
	},
	computed: {
		...serviceComputed,
		...rootComputed
	},
	methods: {
		...serviceMethods,

		async searchList(currentPage = 1, pageUnit = this.groups.pageUnit) {
			this.$sf_toggleLoading(true);
			let searchParams = {
				plantCd: this.plant,
				startDt: this.startDt ? this.startDt : this.$moment(this.searchDate[0]).format('YYYYMMDD'),
				endDt: this.endDt ? this.endDt : this.$moment(this.searchDate[1]).format('YYYYMMDD'),
				logType: this.logType,
				procId: this.procId,
				message: this.message,
				chkFlag: this.chkFlag ? '1' : ''
			};
			await this.getErrorLogList_({ searchParams, currentPage, pageUnit })
				.then(header => {})
				.catch(e => {
					this.$sf_toast({
						title: 'error',
						type: 'error',
						position: 'bottom-right',
						message: this.getMessage_(e.header.messageCd)
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		async getDefaultSelect() {
			await this.getPlants_()
				.then(header => {
					// 아직 sf_setToastOption 안됨
					// 어디에만 띄울지도 확인 필요
					// this.$sf_toast({
					// 	...this.$sf_setToastOption(header),
					// 	message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message,
					// });
					// this.$sf_toast({
					// 	icon: header.code === 0 ? 'ok' : 'error',
					// 	title: header.message,
					// 	position: 'bottom-right',
					// 	message: header.message,
					// });
				})
				.catch(e => {
					this.$sf_toast({
						title: 'Error',
						type: 'error',
						position: 'bottom-right',
						message: e.header.message
					});
				});
			await this.defaultSelect({ optionNm: 'plants', valueNm: 'plant' });
			await this.getLogTypes_({ plantCd: this.plant, commCdType: 'MSG_TYPE' })
				.then(header => {
					// this.$sf_toast({
					// 	icon: header.code === 0 ? 'ok' : 'error',
					// 	title: header.message,
					// 	position: 'bottom-right',
					// 	message: header.message,
					// });
				})
				.catch(e => {
					this.$sf_toast({
						title: 'Error',
						type: 'error',
						position: 'bottom-right',
						message: e.header.message
					});
				});
			await this.changeValue({ name: 'logType', value: this.logTypes[0].value });
		},
		async pageLoad() {
			await this.getDefaultSelect();
			await this.searchList();
		},
		onChangeSelect(key, value) {
			if (key === 'searchDate') {
				this.defaultAssign_({ key: 'startDt', value: this.$moment(value[0]).format('YYYYMMDD') });
				this.defaultAssign_({ key: 'endDt', value: this.$moment(value[1]).format('YYYYMMDD') });
			} else this.defaultAssign_({ key, value });

			this.searchList();
		}
	},
	created() {
		this.pageLoad();
	},
	watch: {
		langCd() {
			this.getLogTypes_({ plantCd: this.plant, commCdType: 'MSG_TYPE' })
				.then(header => {
					// this.$sf_toast({
					// 	icon: header.code === 0 ? 'ok' : 'error',
					// 	title: header.message,
					// 	position: 'bottom-right',
					// 	message: header.message,
					// });
				})
				.catch(e => {
					this.$sf_toast({
						title: 'Error',
						type: 'error',
						position: 'bottom-right',
						message: e.header.message
					});
				});
		}
	}
};
</script>
<style>
.flexStyle {
	display: flex;
}
</style>
